import * as types from '../types/order';
import {List, Map} from 'immutable';
import {updateState} from '../helpers/index';

export default function Order(state = Map({
  list: List(),
  reorder: List(),
  startFetch: false,
}), action) {
  switch (action.type) {
    case types.ORDER_FETCH:
      return updateState(state, {
        list: action.data,
      });
    case types.ORDER_FETCH_REORDER:
      return updateState(state, {
        reorder: action.data
      });
    case types.ORDER_CREATED:
      return updateState(state);
    case types.ORDER_START_FETCH:
      return updateState(state, {
        startFetch: true,
      });
    case types.ORDER_END_FETCH:
      return updateState(state, {
        startFetch: false,
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/order.js